import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ConfigService } from '../../services/config/config.service';
import { TabService } from '../../services/tab/tab.service';
import { CommsService } from '../../services/comms/comms.service';
import { PurchaseOrderService } from '../../services/purchase-order/purchase-order.service';
import { DataService } from '../../services/data/data.service';
import { DisplayService } from '../../services/display/display.service';
import { ContractorService } from '../../services/contractor/contractor.service';
import { TimesheetService } from '../../services/timesheet/timesheet.service';
import { UserService } from '../../services/user/user.service';
import { TableFilterService } from '../../services/table-filter/table-filter.service';

@Component({
	selector: 'pcm-ui-tabs',
	templateUrl: './ui-tabs.component.html',
	styleUrls: ['./ui-tabs.component.scss']
})
export class UiTabsComponent implements OnInit, OnDestroy {

	@Input() tabsData = [];
	@Input() objService: any;
	@Input() clickFlag = 'standard';
	@Input() tooltip = '';
	@Input() dataObj = '';
	@Input() exportCSV = false;

	showExportModal = false;
	exportFilename = this.dataObj + '.csv';
	exportAllListener;
	// need export all to csv only when waitingExport is true
	// since there are some cases no need call export when load all is completed
	awaitingExport = false;

	constructor(
		private commsService: CommsService,
		private configService: ConfigService,
		public tabService: TabService,
		private dataService: DataService,
		private displayService: DisplayService,
		private contractorService: ContractorService,
		private purchaseOrderService: PurchaseOrderService,
		private timesheetService: TimesheetService,
		private userService: UserService,
		private tableFilterService: TableFilterService
	) { }

	ngOnInit() {
		this.objService.checkTabs(this.tabsData);
		this.exportAllListener = this.dataService.loadAllListener().subscribe((listenerEvent) => {
			if (this.awaitingExport) {
				this.handleExportAll(listenerEvent);
			}
		});
	}

	ngOnDestroy() {
		this.exportAllListener.unsubscribe();
	}

	handleExportAll(event) {
		this.awaitingExport = false;
		this.commsService.exportToCSV(this.exportFilename, this.configService.getTableFields(this.dataObj, false), event.data);
	}

	public checkTabs() {
		console.log('UI CHECK TABS');
		this.objService.checkTabs(this.tabsData);
	}

	getActiveTab() {
		let activeTab = {};
		this.tabsData.forEach(function (d, i) {
			if (d.active) {
				activeTab = d;
			}
		});
		return activeTab;
	}

	exportToCSV(event) {
		this.exportFilename = event.data;
		const self = this;
		const delay = setTimeout(function () {
			self.closeExportModal();
		}, 1000);
		const activeTab = this.getActiveTab();
		activeTab['filename'] = this.exportFilename;
		this.awaitingExport = true;
		this.objService.loadAllforTab(activeTab);
	}

	exportAllToCSV() {
		this.showExportModal = true;
	}

	closeExportModal() {
		this.showExportModal = false;
	}

	showSearch() {
		this.objService.showTabSearch(this.tabsData);
		this.displayService.resizeWindow();
		// const self = this;
		// const delay = setTimeout(function () {
		// 	self.dis
		// }, 1000);
	}

	showActiveFilterIcon(currentTab: string): boolean {
		return this.tableFilterService.hasActiveFilter(this.objService.getActiveTab(this.tabsData).tableFilters)
			&& this.objService.getActiveTab(this.tabsData).prop === currentTab;
	}

	getTabTooltip(currentTab: string): string {
		if (this.showActiveFilterIcon(currentTab)) {
			return 'A filter is applied. Some results may be hidden.';
		} else {
			return '';
		}
	}
}
